<template>
    <div class="sort">
        <label for="sort1">Sort by:</label>
        <select id="sort1" v-model="mySort">
            <option value="price-desc">Price high to low</option>
            <option value="price-asc">Price low to high</option>

            <option value="sqft-desc">Sq. ft. high to low</option>
            <option value="sqft-asc">Sq. ft. low to high</option>

            <option value="acres-desc">Acres high to low</option>
            <option value="acres-asc">Acres low to high</option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            mySort: this.value,
        };
    },

    watch: {
        mySort: {
            handler() {
                this.$emit('input', this.mySort);
            },
        },
    },
}
</script>

<style lang="scss">
.sort {
    text-align: right;

    * {
        font-family: sans-serif;
    }
}
</style>
